import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: "tr",
		supportedLngs: ["tr", "en"],
		ns: ["common"],
		defaultNS: "common",
		interpolation: {
			escapeValue: false,
		},
		backend: {
			loadPath: "/locales/{{lng}}/{{ns}}.json",
			...(import.meta.env.DEV ? { requestOptions: { cache: "no-store" as RequestCache } } : {}),
		},
		detection: {
			order: ["localStorage", "cookie", "navigator"],
			caches: ["localStorage", "cookie"],
		},
	});

export default i18n;
